import React from 'react';
import { observer, inject } from 'mobx-react';
import Form, { DateInput, FormBody, SelectInput, SwitchInput, TextInput } from "../../Form";
import { observable } from 'mobx';
import FormMultiSelectInput from '../../FormMultiSelectInput';

@inject('workOrderStatusStore', 'maintenanceTypeStore', 'priorityStore', 'workOrderStore', 'userStore', 'stationStore', 'locationStore', 'locationTypeStore', 'reportingTemplateStore')
@observer
class WorkOrderInfoTable extends React.Component {
  state = {
    search: ''
  };
  @observable multiStationOptions = [];

  onStationSelect = (item) => {
    const { workOrderStore } = this.props;
    item.value = !item.value;
    workOrderStore.onChangeSelectedStations(this.multiStationOptions.filter(item => !!item.value).map(item => +item.id));
  }

  onStationSelectAll = stations => {
    const { workOrderStore } = this.props;
    this.multiStationOptions = stations;
    workOrderStore.onChangeSelectedStations(stations.filter(item => !!item.value).map(item => +item.id));
  }

  componentDidMount() {
    const { locationStore, locationTypeStore } = this.props;

    if (!locationStore.items.length && !locationStore.isLoading) locationStore.fetchItems();
    if (!locationTypeStore.items.length && !locationTypeStore.isLoading) locationTypeStore.fetchItems();

    this.populateOptions();
  }

  populateOptions = () => {
    const { stationStore, workOrderStore } = this.props;
    if (stationStore.items.length === 0) {
      setTimeout(() => {
        this.populateOptions();
      }, 300)
    } else {
      this.multiStationOptions = stationStore.items.map(item => ({ id: item.id, name: item.name, label: item.name, value: true, tags: item.tags }));
      workOrderStore.onChangeSelectedStations(stationStore.items.map(item => +item.id));
    }
  };

  onChangeSelectedUser = (e) => {
    this.setState({
      search: e.target.value
    });
  };

  renderInfoTable = () => {
    const { workOrderStatusStore, maintenanceTypeStore, priorityStore, workOrderStore, userStore } = this.props;
    const { search } = this.state;

    let work_orders = [];

    const markers = workOrderStore.getMarkers();

    markers.map(item => {
      work_orders.push(...item.work_orders)
    });

    const rowStyle = (id) => ({ cursor: 'pointer', background: workOrderStore.show === id ? '#e6e6e6' : 'white' });
    const filterSearchedUser = users => {
      if (this.state.search === '') return users;
      else return users.filter(u => (u.name && u.name.includes(search)) || (u.username && u.username.includes(search)) || (u.email && u.email.includes(search)));
    }

    return (
      <div className='bordered side-table'>
        <div className='DataTable'>
          <table>
            <tbody>
              {+workOrderStore.viewBy === 1 && workOrderStatusStore.items.map(item => (
                <tr onClick={() => workOrderStore.onChangeShow(item.id)} style={rowStyle(item.id)} key={`status-${item.id}`}>
                  <td><i className='fa fa-circle' style={{ color: item.color }} /></td>
                  <td>{item.caption}</td>
                  <td>{work_orders ? work_orders.filter(work_order => work_order && +work_order.status.id === +item.id).length : '-'}</td>
                </tr>
              ))}
              {+workOrderStore.viewBy === 2 && priorityStore.items.map(item => (
                <tr onClick={() => workOrderStore.onChangeShow(item.id)} style={rowStyle(item.id)} key={`priority-${item.id}`}>
                  <td><i className='fa fa-circle' style={{ color: item.color }} /></td>
                  <td>{item.caption}</td>
                  <td>{work_orders ? work_orders.filter(work_order => work_order && +work_order.priority.id === +item.id).length : '-'}</td>
                </tr>
              ))}
              {+workOrderStore.viewBy === 3 && maintenanceTypeStore.items.map(item => (
                <tr onClick={() => workOrderStore.onChangeShow(item.id)} style={rowStyle(item.id)} key={`maintenance_type-${item.id}`}>
                  <td><i className='fa fa-circle' style={{ color: item.color }} /></td>
                  <td>{item.caption}</td>
                  <td>{work_orders ? work_orders.filter(work_order => work_order && +work_order.maintenance_type.id === +item.id).length : '-'}</td>
                </tr>
              ))}
              {+workOrderStore.viewBy === 4 && filterSearchedUser(workOrderStore.assignees).map(user => {
                return <tr onClick={() => workOrderStore.onChangeShow(user.id)} style={rowStyle(user.id)} key={`wo-assignee-${user.id}`}>
                  <td><i className='fa fa-circle' style={{ color: user.color }} /></td>
                  <td>{user.name}</td>
                  <td>{work_orders ? work_orders.filter(work_order => work_order && +work_order.assigned_to === +user.id).length : '-'}</td>
                </tr>
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  _renderLocationFilterIinputs = () => {
    const { workOrderStore, locationStore, locationTypeStore } = this.props;
    return (
      <div>
        <SelectInput label='Location Type' value={workOrderStore.filters.location_type_id}
          options={[{ id: 0, name: 'All' }, ...locationTypeStore.items]} isLoading={locationTypeStore.isLoading}
          onChange={e => workOrderStore.onChangeFilters('location_type_id', e)} fields={{ label: 'name', value: 'id' }} />
        {workOrderStore.filters.location_type_id !== 0 && <SelectInput label='Location' value={workOrderStore.filters.location_id}
          options={[{ id: 0, name: 'All' }, ...locationStore.items.filter(item => item.type_id === workOrderStore.filters.location_type_id)]} isLoading={locationStore.isLoading}
          onChange={e => workOrderStore.onChangeFilters('location_id', e)} fields={{ label: 'name', value: 'id' }}
        />}
      </div>
    )
  }

  downloadReport = (e, format) => {
    e.preventDefault();
    const { workOrderStore, workOrderStatusStore, maintenanceTypeStore, priorityStore, stationStore, userStore, reportingTemplateStore } = this.props;
    let csv = ['S.No.,Title,Station,Division,District,Status,Priority,Maintenance Type,Created On,Scheduled On, Completion Deadline,Created By,Assigned To'];
    workOrderStore.filteredWorkOrders.forEach((item, i) => {
      let station = !!item.station.length && stationStore.findById(item.station[0].id),
        division = !!station && !!station.meta_data && station.meta_data.find(item => item.name === 'Division'),
        district = !!station && !!station.meta_data && station.meta_data.find(item => item.name === 'District');
      let created_by = userStore.findById(item.created_by),
        assignedTo = userStore.findById(item.assigned_to),
        status = workOrderStatusStore.findById(item.status_id),
        priority = priorityStore.findById(item.priority_id),
        type = maintenanceTypeStore.findById(item.maintenance_type);

      csv.push([
        i + 1,
        item.title,
        !!station ? station.name : '',
        !!division ? division.value : '',
        !!district ? district.value : '',
        !!status ? status.caption : '',
        !!priority ? priority.caption : '',
        !!type ? type.caption : '',
        item.creation_date || '',
        item.scheduled_date || '',
        item.completion_deadline || '',
        !!created_by ? created_by.name : '',
        !!assignedTo ? assignedTo.name : '',
      ].join(','));
    });
    reportingTemplateStore.downloadReport(
      csv.join('\n'),
      format,
      {
        report_name: 'Work Order Report',
        orientation: 'landscape'
      },
    );
  }

  render() {
    const { workOrderStore, stationStore } = this.props;
    const { filters } = workOrderStore;

    return <div className='ticket-filter-group'>
      <Form>
        <FormBody>
          <SwitchInput label='Filter By Location' value={filters.filter_by_location} onChange={() => workOrderStore.onChangeFilters('filter_by_location', { target: { value: !filters.filter_by_location } })} />
          {!filters.filter_by_location &&
            <FormMultiSelectInput
              id='station-multi-select'
              label='Stations'
              options={this.multiStationOptions}
              optionClicked={this.onStationSelect}
              optionsChangeAll={this.onStationSelectAll}
              isLoading={stationStore.isLoading}
              filterOptions={stationStore.filterStations}
            />}
          {filters.filter_by_location && this._renderLocationFilterIinputs()}
          <DateInput type={'date'} label={'Date From'} value={workOrderStore.filters.date_from} onChange={e => workOrderStore.onChangeFilters('date_from', e)} />
          <DateInput type={'date'} label={'Date To'} value={workOrderStore.filters.date_to} onChange={e => workOrderStore.onChangeFilters('date_to', e)} />
          <div className='flex' style={{ marginBottom: 10 }}>
            <button onClick={e => this.downloadReport(e, 'PDF')}>Print</button>
            <button onClick={e => this.downloadReport(e, 'CSV')}>Download CSV</button>
          </div>
        </FormBody>
      </Form>
      <div className='full-width overflow-x-scroll'>
        <div className='TabBar TabBarRounded'>
          <ul>{workOrderStore.viewByOptions.map(({ id, name }) => (
            <li key={`ticket-view-by-options-${id}`}
              className={id === workOrderStore.viewBy ? 'active' : ''}
              onClick={() => workOrderStore.onChangeViewBy(id)}>
              <a>{name}</a>
            </li>
          ))}</ul>
        </div>
      </div>
      {[4, 5].includes(+workOrderStore.viewBy) && <Form>
        <FormBody>
          <TextInput label={'Search User'} value={this.state.search} onChange={this.onChangeSelectedUser} />
        </FormBody>
      </Form>}
      {this.renderInfoTable()}
    </div>
  }
}

export default WorkOrderInfoTable;



// WEBPACK FOOTER //
// ./src/components/Maintenance/WorkOrder/WorkOrderInfoTable.js